import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import get from 'lodash/get';

import { LANG } from '~/constans/commom';
import { useGetDealerPanelQuery } from '~/schemas/generated/graphql';
import { useCurrentDealerId } from '~/shared/hooks/useCurrentDealerId';

import cls from './DealerInfoPanel.less'

interface IDealerData {
  id?: string;
  DealerId?: string;
  DealerName?: string;
  DealerNameEn?: string;
  [key: string]: unknown;
}

interface DealerInfoPanelProps {
  /** Данные дилера (например, из нарушения). Если не переданы — берутся по currentDealerId из sessionStorage. */
  Dealer?: IDealerData;
}

const DEALER_INFO = ["FO", "subject", "city", "INN", "code"];
const LOCALIZE_DEALER_INFO = ["FO", "subject", "city"];

/*
Новый компонент DealerInfoPanel. В будущем, возможно, нужно добавить по необходимости некоторую логику со старой реализации
 */
export const DealerInfoPanel = (props: DealerInfoPanelProps) => {

  const {
    Dealer,
  } = props;

  const { t } = useTranslation();
  const isEn = localStorage.getItem("language") === LANG.en;

  const currentDealerId = useCurrentDealerId();

  // Если Dealer передан через пропсы (например, на странице нарушения),
  // используем его ID — иначе currentDealerId из sessionStorage
  const dealerIdFromProp = Dealer?.id || Dealer?.DealerId;

  const { data, loading } = useGetDealerPanelQuery({
    variables: {
      DealerId: dealerIdFromProp || currentDealerId,
    },
  });

  const dealerPanel = (Dealer || (get(data, "DealerGetter.getDealer") as Record<string, unknown>) || {}) as Record<string, string>;

  const { DealerName = "", DealerNameEn = "" } = dealerPanel;

  const list = useMemo(() => {
    return DEALER_INFO.map((InfoPanel) => {
      const currentOption =
        LOCALIZE_DEALER_INFO.includes(InfoPanel) && isEn
          ? `${InfoPanel}En`
          : InfoPanel;

      return {
        label: t(`dealerPanel.${InfoPanel}`),
        value: dealerPanel[currentOption] || '-'
      }
    })
  }, [dealerPanel])

  return (
    <div className={cls.DealerPanel}>
      <div className={cls.DealerName}>{isEn ? DealerNameEn : DealerName}</div>
      <div className={cls.separator} />
      <div className={cls.DealerInfo}>
        {list.map((item) => (
          <div key={item.label} className={cls.DealerItem}>
            <div>
              {item.label}
            </div>
            <div className={cls.value}>
              {loading ? <Skeleton width={55} /> : item.value}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
